/**
 * This lists all possible names of
 * supported Feature Flags
 */
export enum FeatureFlag {
  // Feature Flags
  // FEATURE_NAME = 'posthog-feature-id',
  IPPS_INTEGRATION = 'ipps-integration',
  FIRECRAWL_INTEGRATION = 'firecrawl-integration',
  GROUP_EVENTS = 'group-events',
}
